/* angular:styles/component:css;4fffb46de0e1794280b3a97ac617e8415e3a389c0c21ea1135f6d922f9d11a00;C:\My Projects\CF_Agent_Builder\src\app\shared-module\components\whatsapp-message-dialog\whatsapp-message-dialog.component.ts */
.whatsapp-send {
  background: var(--ion-color-secondary-shade) !important;
  color: #fff !important;
}
.wa-dialog-shell {
  --wa-primary: #0f8f63;
  --wa-primary-soft: #e9f9f2;
  --wa-border: #d8e7df;
  --wa-text: #14382b;
  --wa-muted: #567468;
  display: flex;
  flex-direction: column;
  gap: 14px;
  min-width: 280px;
  max-height: min(85vh, 760px);
  overflow: hidden;
}
.wa-scroll-region {
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding-bottom: 2px;
}
.wa-dialog-header {
  display: flex;
  align-items: center;
  gap: 12px;
  background:
    linear-gradient(
      135deg,
      #effff8 0%,
      #f6fbff 100%);
  border: 1px solid var(--wa-border);
  border-radius: 14px;
  padding: 14px;
}
.wa-header-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: grid;
  place-items: center;
  background: #d8f7ea;
  color: var(--wa-primary);
  font-size: 24px;
}
.wa-header-copy {
  flex: 1;
}
.wa-header-copy h2 {
  margin: 0;
  font-size: 15px;
  color: var(--wa-text);
}
h2 {
  line-height: normal;
}
.wa-header-copy p {
  margin: 4px 0 0;
  font-size: 12px;
  color: var(--wa-muted);
}
.wa-close-btn {
  color: #2e4c41;
}
.wa-dialog-body {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0 10px;
}
.wa-search-field {
  width: 100%;
}
.wa-content-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}
.wa-list-panel,
.wa-preview-panel {
  border: 1px solid var(--wa-border);
  border-radius: 12px;
  background: #fff;
}
.wa-list-head,
.wa-preview-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  border-bottom: 1px solid #edf4f0;
  color: var(--wa-text);
  font-weight: 500;
}
.wa-count {
  background: var(--wa-primary-soft);
  border-radius: 999px;
  padding: 2px 8px;
  font-size: 12px;
  color: var(--wa-primary);
}
.wa-message-list {
  max-height: 320px;
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px;
}
.wa-message-card {
  text-align: left;
  border: 1px solid #dce9e3;
  border-radius: 10px;
  background: #fff;
  padding: 10px;
  cursor: pointer;
  transition:
    border-color 0.2s ease,
    transform 0.2s ease,
    box-shadow 0.2s ease;
}
.wa-message-card:hover {
  border-color: #9acfb8;
  transform: translateY(-1px);
  box-shadow: 0 8px 16px rgba(19, 86, 58, 0.08);
}
.wa-message-card--active {
  border-color: var(--wa-primary);
  background: #f5fff9;
  box-shadow: 0 0 0 1px var(--ion-color-secondary-shade) inset;
}
.wa-card-header {
  font-weight: 600;
  color: #1d4133;
  margin-bottom: 4px;
}
.wa-preview-content {
  padding: 12px;
  max-height: 320px;
  overflow: auto;
}
.wa-preview-content p {
  margin: 0;
  color: #4e6a5e;
  white-space: pre-wrap;
}
.wa-empty-state,
.wa-empty-preview {
  min-height: 240px;
  display: grid;
  place-content: center;
  text-align: center;
  color: #7a9388;
  gap: 6px;
}
.wa-dialog-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  flex: 0 0 auto;
  padding: 0 10px 10px;
  background: #fff;
  z-index: 2;
}
@media (max-width: 768px) {
  .wa-content-grid {
    grid-template-columns: 1fr;
  }
  .wa-message-list {
    max-height: 220px;
  }
}
/*# sourceMappingURL=whatsapp-message-dialog.component.css.map */
